export const SET_NEW_LOCALE = '[LANGUAGE] Set new locale';
